/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Ideas_TitleInputs */

const en_directory_ai_tools_ideas_title = /** @type {(inputs: Directory_Ai_Tools_Ideas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who to make it with`)
};

const zh_directory_ai_tools_ideas_title = /** @type {(inputs: Directory_Ai_Tools_Ideas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以和谁一起做`)
};

/**
* | output |
* | --- |
* | "Who to make it with" |
*
* @param {Directory_Ai_Tools_Ideas_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_ideas_title = /** @type {((inputs?: Directory_Ai_Tools_Ideas_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Ideas_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_ideas_title(inputs)
	return zh_directory_ai_tools_ideas_title(inputs)
});
export { directory_ai_tools_ideas_title as "directory.ai_tools.ideas_title" }